import { render } from "./Footer.vue?vue&type=template&id=b74cdf62&scoped=true"
const script = {}

import "./Footer.vue?vue&type=style&index=0&id=b74cdf62&scoped=true&lang=css"

import exportComponent from "/Users/jessicabohland/Documents/Code/Website/gonsbachtal-website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b74cdf62"]])

export default __exports__